import { Injectable, inject } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthenticationService } from './authentication.service';

/** Si el usuario ya inició sesión, la ruta de login lo manda al dashboard. */
@Injectable({ providedIn: 'root' })
export class NoAuthGuard implements CanActivate {
  private router = inject(Router);
  private authenticationService = inject(AuthenticationService);

  async canActivate(): Promise<boolean> {
    const isLoggedIn = await this.authenticationService.isLoggedIn();
    if (!isLoggedIn) return true;

    this.router.navigate(['/dashboard']);
    return false;
  }
}
